<template lang="html">
  <div class="succeed">
    <div class="succeed_module" ref="element" v-show="succeedModule">
      <div class="succeed_content">
        <p class="succeed_title">{{ succeed.title }}</p>
        <div class="succeed_ma">
          <img :src="succeed.qrcode" alt="">
        </div>
        <p class="succeed_txt"> 扫码添加上方微信 </p>
        <p v-html="succeed.tips" class="succeed_tips"></p>
        <p class="succeed_name">恭喜<span v-show="this.name">“ {{ this.name }} ”</span>报名成功</p>
        <div class="cross_line">
          <div class="cross_line_left"></div>
          <div class="cross_line_con"></div>
          <div class="cross_line_right"></div>
        </div>
        <div class="succeed_btn">
          <div class="" @click="btnQQ()">
            <img src="../../assets/image/qqx.png" alt="">
            <span>QQ好友</span>
          </div>
          <div class="" @click="btnVX()">
            <img src="../../assets/image/wx.png" alt="">
            <span>微信好友</span>
          </div>
          <div class="" @click="btnQQ_home()">
            <img src="../../assets/image/Qkong2.png" alt="">
            <span>QQ空间</span>
          </div>
          <div class="" @click="btnVX_home()">
            <img src="../../assets/image/wx_qun.png" alt="">
            <span>朋友圈</span>
          </div>
        </div>
      </div>

      <!-- 浮层 -->
      <div class="reminder" v-show="reminder" @click="reminderBtn()">
        <img src="../../assets/image/reminder.png" alt="">
      </div>

      
      <div class="download_app_btn" v-if="this.$route.query.type_id == 1 || this.$route.query.type_id == 2">
        打开直播间
        <WxOpenTag :extinfo="activityUrl" />
      </div>
      <div class="download_app_btn" v-else>
        打开电巢app
        <WxOpenTag :extinfo="jumpTarget" />
      </div>
      <div class="else_activity_btn" @click="elseActivity">
        查看更多活动
      </div>
    </div>

    <div class="appSucceedModule" v-show="appSucceedModule">
      <div class="appSucceedTitle">
        <p>{{ succeed.title }}</p>
      </div>
      <div class="appSucceedMessage">
        <div class="appSucceedMessage_modile">
          <div class="appSucceedMessage_modile_ma">
            <img :src="succeed.qrcode" alt="">
          </div>
          <p class="succeed_txt"> 扫码添加上方微信 </p>
          <p v-html="succeed.tips" class="succeed_tips"> </p>
          <p class="succeed_name">恭喜 “ <span>{{ this.name }}</span> ” 报名成功</p>
          <div class="succeed_share">
            <div class="liveBroadcast_btn" @click="liveBroadcast" v-if="this.$route.query.type_id == 1 || this.$route.query.type_id == 2">进入直播间</div>
            <div class="signUp_btn" @click="share">分享</div>
          </div>
        </div>
      </div>
      <div class="app_else_activity">
        <div class="app_else_activity_txt">
          <div class="app_else_activity_txt1">相关活动</div>
        </div>
        <div class="app_else_activityCon">
          <div class="" v-for="(m, index) in activity" :key="index">
            <a v-bind:href="[ httphead +'/html/activity/activity.html?hideNativeNav=1&activityId=' + m.id + '' ]" class="else_teacher">
              <img :src="m.cover" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils.js';
  import {pagehost} from '@/utils/http.js';
  import {pagebase} from '@/utils/http.js';
  import WxOpenTag from '@/components/WxOpenTag'

  var Ua = navigator.userAgent;

  export default {
    components: {
      WxOpenTag: WxOpenTag,
    },
    data() {
      return {
        jumpTarget: '',
        succeedModule: false,
        appSucceedModule: false,
        succeed: [],
        activity: [],
        reminder: false,
        height: '',
        moduleHeight: '',
        name: this.$route.query.name,
        httphead: '',
        activityUrl: '',
        activityDetailData: {},
      }
    },
    mounted() {
      this.callApp();
      this.callAppMedia();
      let height = this.$refs.element.offsetHeight;
      this.moduleHeight = height + 'px';
      this.height = document.body.offsetHeight + 'px';
      this.$http({
        url: '/activity/Info',
        method: 'get',
        params: {
          activity_id: this.$route.query.id,
        },
      }).then((res) => {
        this.httphead = pagehost;
        this.succeed = res.data;
        this.$http({
          url: '/activity/detail',
          method: 'get',
          params: {
            activity_id: this.$route.query.id,
          },
        }).then((res) => {
          this.activity = res.data.more_list;
        })
        this.show()
      })
    },
    methods: {
      callApp() {
        let thisUrl = pagehost + '/html/activity/activity.html?activityId=' + this.$route.query.id + '&hideNativeNav=1';
        let path = 'webView/detail?url=' + thisUrl;
        this.jumpTarget = path;
      },
      
      callAppMedia(){
        this.$http({
          url: '/activity/detail',
          method: 'get',
          params: {
            activity_id: this.$route.query.id,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityDetailData = res.data;
            if (this.activityDetailData.is_xiaoe_url) {
              this.activityUrl = 'live/detail?url=' + this.activityDetailData.live_url;
            } else {
              this.activityUrl = res.data.app_live_url;
            }
          }
        })
      },

      liveBroadcast() {
        if (this.activityDetailData.is_xiaoe_url) {
          utils.communicateToNative('openNative', {
            new_url: 'elecnest://live/detail?url=' + this.activityDetailData.live_url,
          });
        } else {
          utils.communicateToNative('openNative', {
            new_url: this.activityDetailData.app_live_url,
          });
        }
      },

      share() {
        this.$http({
          url: '/activity/info',
          method: 'get',
          params: {
            activity_id: this.$route.query.id,
          },
        }).then((res) => {
          var message = {
            type: 'share',
            value: {
              type: 'news',
              title: res.data.title,
              description: res.data.activity_time,
              webpageUrl: pagebase + '/#/activity/details?id=' + this.$route.query.id,
              imageUrl: res.data.cover
            }
          }
          utils.communicateToRN(message);
          utils.communicateToNative('showShare', {
            message: res.data.title,
            picture: res.data.cover,
            url: pagebase + '/#/activity/details?id=' + this.$route.query.id,
          });
        })
      },
      show() {
        if (Ua.search("app_elecnest") != -1) {
          this.succeedModule = false;
          this.appSucceedModule = true;
        } else {
          this.succeedModule = true;
          this.appSucceedModule = false;
        }
      },
      elseActivity() {
        this.$router.push({
          path: '/more',
          query: {
            id: this.$route.query.id,
          }
        })
      },
      /* QQ */
      btnQQ() {
        if (utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()) {
          this.reminder = true;
          this.alertMod = false;
        } else {
          const input = document.createElement('input')
          document.body.appendChild(input)
          input.setAttribute('value', this.succeed.reg_url)
          input.select()
          if (document.execCommand('copy')) {
            document.execCommand('copy')
          }
          document.body.removeChild(input)
          utils.showMessage('活动链接已复制')
        }
      },
      /* VX */
      btnVX() {
        if (utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()) {
          this.reminder = true;
          this.alertMod = false;
        } else {
          const input = document.createElement('input')
          document.body.appendChild(input)
          input.setAttribute('value', this.succeed.reg_url)
          input.select()
          if (document.execCommand('copy')) {
            document.execCommand('copy')
          }
          document.body.removeChild(input)
          utils.showMessage('活动链接已复制')
        }
      },
      /* QQ空间 */
      btnQQ_home() {
        if (utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()) {
          this.reminder = true;
          this.alertMod = false;
        } else {
          const input = document.createElement('input')
          document.body.appendChild(input)
          input.setAttribute('value', this.succeed.reg_url)
          input.select()
          if (document.execCommand('copy')) {
            document.execCommand('copy')
          }
          document.body.removeChild(input)
          utils.showMessage('活动链接已复制')
        }
      },
      /* VX朋友圈 */
      btnVX_home() {
        if (utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ()) {
          this.reminder = true;
          this.alertMod = false;
        } else {
          const input = document.createElement('input')
          document.body.appendChild(input)
          input.setAttribute('value', this.succeed.reg_url)
          input.select()
          if (document.execCommand('copy')) {
            document.execCommand('copy')
          }
          document.body.removeChild(input)
          utils.showMessage('活动链接已复制')
        }
      },
      reminderBtn() {
        this.reminder = false;
        this.alertMod = true;
        this.$emit('headleCancel')
        this.$emit('headleOk')
      },
    },
  }
</script>

<style lang="css" scoped>
  .succeed {
    width: 100%;
    height: 100%;
  }

  .succeed_module {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url('../../assets/image/succeed_bac.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 28px;
    overflow: auto;
  }

  .succeed_content {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 6px;
  }

  .succeed_title {
    text-align: center;
    font-size: 18px;
    padding: 30px 25px 0 25px;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .succeed_ma {
    margin-top: 12px;
    display: flex;
    justify-content: center;
  }

  .succeed_ma img {
    width: 150px;
    height: 150px;
  }

  .succeed_txt {
    margin-top: 10px;
    font-size: 14px;
    color: #1D2023;
    text-align: center;
  }

  .succeed_tips {
    text-align: center;
    font-size: 16px;
    color: #1D2023;
    padding: 0 15px;
  }

  .succeed_tips span {
    color: #E50120;
  }

  .succeed_name {
    padding-top: 16px;
    text-align: center;
    font-size: 16px;
    color: #1D2023;
  }

  .succeed_name span {
    color: #4A90E2;
  }

  .cross_line {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cross_line_left {
    width: 14px;
    height: 28px;
    border-radius: 0 14px 14px 0;
    background-color: #F33A24;
  }

  .cross_line_con {
    width: 100%;
    height: 1px;
    border-bottom: 0.5px dashed #A6A9BA;
  }

  .cross_line_right {
    width: 14px;
    height: 28px;
    border-radius: 14px 0 0 14px;
    background-color: #EF1F15;
  }

  .succeed_share {
    display: flex;
    justify-content: center;
    padding: 15px 0;
  }

  .liveBroadcast_btn {
    width: 150px;
    background-color: red;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 40px;
    color: #ffffff;
    margin-right: 5px;
  }

  .signUp_btn {
    width: 150px;
    background-color: red;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 40px;
    color: #ffffff;
    margin-left: 5px;
  }

  .succeed_btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .succeed_btn div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
    font-size: 11px;
  }

  .succeed_btn div span {
    margin-top: 5px;
  }

  .succeed_btn img {
    width: 42px;
  }

  .else_activity_btn {
    width: 100%;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #F5A623;
    font-size: 16px;
    background-color: #ffffff;
    border-radius: 6px;
    margin-top: 10px;
  }

  .download_app_btn {
    position: relative;
    width: 100%;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #E50120;
    font-size: 16px;
    background-color: #ffffff;
    border-radius: 6px;
    margin-top: 35px;
  }

  .reminder {
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    left: 0;
    top: 0;
    margin: 0 auto;
    height: 100%;
    padding: 28px 0;
  }

  .reminder img {
    width: 100%;
  }

  @media (min-width: 750px) {
    .succeed_content {
      height: 750px
    }

    .succeed_ma img {
      width: 350px;
      height: 350px;
    }

    .succeed_btn {
      padding-bottom: 30px;
    }

    .reminder {
      padding: 28px 0;
      left: 50%;
      margin-left: -375px;
    }
  }

  .appSucceedModule {
    height: 100%;
    background-color: #F7F8F8;
  }

  .appSucceedTitle {
    box-sizing: border-box;
    width: 100%;
    height: 135px;
    background: linear-gradient(to right, #E50101, #FE405A);
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 15px;
    font-size: 24px;
    color: #ffffff;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .appSucceedTitle p {
    overflow: hidden;
  }

  .appSucceedMessage {
    padding: 0 15px;
  }

  .appSucceedMessage_modile {
    background-color: #ffffff;
    margin-top: -35px;
    box-shadow: 0px 0px 10px -2px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  .appSucceedMessage_modile_ma {
    display: flex;
    justify-content: center;
    padding-top: 25px;
  }

  .appSucceedMessage_modile_ma img {
    width: 180px;
    height: 180px;
    object-fit: cover;
  }

  .app_else_activity {
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 15px;
    background-color: #ffffff;
  }

  .app_else_activity_txt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
  }

  .app_else_activity_txt1 {
    font-size: 18px;
    font-weight: 600;
    color: #1D2023;
  }

  .app_else_activity_txt2 {
    font-size: 10px;
    color: #606972;
  }

  .app_else_activityCon {
    box-sizing: border-box;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    overflow-x: auto;
  }

  .app_else_activityCon div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .app_else_activityCon div img {
    width: 135px;
    height: 93px;
    object-fit: cover;
    border-radius: 5px;
    margin-right: 13px;
  }
</style>
